import { render } from "./IconChevronRight.vue?vue&type=template&id=1c05115a&scoped=true"
const script = {}

import "./IconChevronRight.vue?vue&type=style&index=0&id=1c05115a&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c05115a"]])

export default __exports__